import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, perfixLineColumn, dateColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import { useHistory } from "react-router-dom";
import { formatDateTH } from "../../../utilities/DateUtil";
import { dataUserSession } from "../../../utilities/dataSession";

export default function P107List({ dataTable, setDialog, searchData }) {
    const [userRole] = useState(dataUserSession() && dataUserSession().userRole ? dataUserSession().userRole : "");
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const history = useHistory();
    // const [globalFilter] = useState(null);

    const checkDash = () => {
        if (userRole === 3 || userRole === "A") {
            history.push("/301");
        } else {
            history.push("/");
        }
    };

    const headerLabel = <span className="hidden-responsive">ค้นหางานสั่งการเฉพาะอย่าง</span>;
    const header = (
        <div className="table-header" style={{ padding: "2px" }}>
            <div>
                <Button
                    className="p-button-secondary p-button btn-hidden-responsive"
                    icon="pi pi-arrow-left"
                    label="กลับหน้าจอหลัก"
                    // style={{ width: 150, marginLeft: '5px' }}
                    onClick={() => checkDash()}
                />
            </div>
            <div>
                <Button
                    className="p-button btn-hidden-responsive"
                    label={headerLabel}
                    icon="pi pi-search"
                    onClick={() => {
                        history.push({
                            pathname: "/111",
                            state: { dataSrh: searchData },
                        });
                    }}
                />
            </div>
        </div>
    );
    const actionOpenOrder = (rowData) => {
        let labelShow = <span className="show-responsive">เปิดเป็นคำร้อง</span>;
        let isDisabled = rowData && rowData.enableEditFlag && rowData.enableEditFlag === "Y" ? true : false;
        return (
            <React.Fragment>
                <div style={{ textAlign: "center" }}>
                    {isDisabled && isDisabled === true ? (
                        <Button
                            icon="pi pi-file"
                            className="p-button p-button-warning btn-label-responsive btn-md-responsive"
                            onClick={() => {
                                history.push({
                                    pathname: "/104",
                                    state: {
                                        form: "107",
                                        orderNo: rowData.orderNo,
                                        action: "NEW",
                                    },
                                });
                            }}
                            tooltip="คลิกเพื่อ เปิดเป็นใบแจ้งฯ"
                            tooltipOptions={{ position: "top" }}
                            label={labelShow}
                        />
                    ) : (
                        ""
                    )}
                </div>
            </React.Fragment>
        );
    };

    const dateColumn2 = (rowData, isTime, checkColumn, titleShow) => {
        let date = { ...rowData };
        let datevalue = date[`${checkColumn}`];
        let date_arr = datevalue && datevalue !== null ? datevalue.split("-") : [];
        let newDate = date_arr.length === 3 ? date_arr[0] + "/" + date_arr[1] + "/" + date_arr[2] : "";
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                {newDate && newDate !== "" ? formatDateTH(newDate, isTime) : "-"}
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
            <DataTable
                // ref={(el) => dt = el}
                value={dataTable}
                dataKey="id"
                paginator
                first={pageConf.first}
                rows={pageConf.rows}
                onPage={(e) => onPageChange(e, setPageConf)}
                rowsPerPageOptions={rowsPerPageOptions()}
                paginatorTemplate={paginatorTemplate()}
                currentPageReportTemplate={currentPageReportTemplate()}
                header={header}
                // globalFilter={globalFilter}
                emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                selectionMode="single"
            >
                <Column sortable field="orderNo" header="เลขที่งานสั่งการเฉพาะอย่าง" body={(e) => normalColumn(e, "orderNo", "เลขที่งานสั่งการเฉพาะอย่าง")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                <Column sortable field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNo", "เลขที่สัญญา")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                <Column field="routeName" header="เส้นทาง" body={(e) => normalColumn(e, "routeName", "เส้นทาง")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column sortable field="orderDate" header="วันที่สั่ง" body={(e) => dateColumn2(e, false, "orderDate", "วันที่สั่ง")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="supervisorName" header="ผู้สั่ง" body={(e) => normalColumn(e, "supervisorName", "ผู้สั่ง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="orderDetail" header="การสั่งการเฉพาะอย่าง" body={(e) => perfixLineColumn(e, "orderDetail", "การสั่งการเฉพาะอย่าง")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="guidelineNo" header="เป็นแนวทางปฏิบัติตามข้อ" body={(e) => normalColumn(e, "guidelineNo", "เป็นแนวทางปฏิบัติตามข้อ")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="fixExpireDate" header="ปรับปรุงแก้ไขภายในวันที่" body={(e) => dateColumn(e, false, "fixExpireDate", "ปรับปรุงแก้ไขภายในวันที่")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="urgentFixExpireDate" header="เร่งรัดดำเนินการภายในวันที่" body={(e) => dateColumn(e, false, "urgentFixExpireDate", "เร่งรัดดำเนินการภายในวันที่")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="replyExpireDate" header="ตอบกลับเป็นหนังสือภายในวันที่" body={(e) => dateColumn(e, false, "replyExpireDate", "ตอบกลับเป็นหนังสือภายในวันที่")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="orderStatus" header="สถานะ" body={(e) => normalColumn(e, "orderStatus", "สถานะ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column header="เปิดเป็นใบแจ้งฯ" body={(e) => actionOpenOrder(e)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
            </DataTable>
            {/* </div> */}
        </div>
    );
}
